import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6 text-center">
      <h1 className="text-6xl font-bold mb-4 text-gray-800">404</h1>
      <h2 className="text-2xl font-semibold mb-4 text-gray-700">Sidan kunde inte hittas</h2>
      <p className="mb-6 text-gray-600">
        Oops! Den sida du letar efter finns inte eller har flyttats.
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-green-700 text-white rounded hover:bg-green-800 transition"
      >
        Gå till startsidan
      </Link>
    </div>
  );
}

export default NotFound;
